import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Login from "@/pages/login/page";
import ResetPassword from "@/pages/reset-password/page";
import Dashboard from "@/pages/dashboard/page";
import Inventory from "@/pages/inventory/page";
import ReceiveStock from "@/pages/receive/page";
import IssueStock from "@/pages/issue/page";
import Invoices from "@/pages/invoices/page";
import Visits from "@/pages/visits/page";
import Reports from "@/pages/reports/page";
import Users from "@/pages/users/page";
import Settings from "@/pages/settings/page";
import Locations from "@/pages/locations/page";
import Categories from "@/pages/categories/page";
import ProtectedRoute from "@/components/ProtectedRoute";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/inventory",
    element: (
      <ProtectedRoute requiredRole="admin">
        <Inventory />
      </ProtectedRoute>
    ),
  },
  {
    path: "/receive",
    element: (
      <ProtectedRoute requiredRole="admin">
        <ReceiveStock />
      </ProtectedRoute>
    ),
  },
  {
    path: "/issue",
    element: (
      <ProtectedRoute>
        <IssueStock />
      </ProtectedRoute>
    ),
  },
  {
    path: "/invoices",
    element: (
      <ProtectedRoute>
        <Invoices />
      </ProtectedRoute>
    ),
  },
  {
    path: "/visits",
    element: (
      <ProtectedRoute>
        <Visits />
      </ProtectedRoute>
    ),
  },
  {
    path: "/reports",
    element: (
      <ProtectedRoute requiredRole="admin">
        <Reports />
      </ProtectedRoute>
    ),
  },
  {
    path: "/users",
    element: (
      <ProtectedRoute requiredRole="admin">
        <Users />
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings",
    element: (
      <ProtectedRoute>
        <Settings />
      </ProtectedRoute>
    ),
  },
  {
    path: "/locations",
    element: (
      <ProtectedRoute requiredRole="admin">
        <Locations />
      </ProtectedRoute>
    ),
  },
  {
    path: "/categories",
    element: (
      <ProtectedRoute requiredRole="admin">
        <Categories />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
